import { Injectable } from '@angular/core';
import { defaultsDeep } from 'lodash';
import { BehaviorSubject } from 'rxjs';

import { DEFAULT_FILTERS, IFilters } from '../models/filters';

@Injectable({ providedIn: 'root' })
export class FiltersService {
    filtersMap: Map<string, BehaviorSubject<IFilters>> = new Map();

    /** add a new plots filters to our map */
    initPlotFilters( plotId: string ) {
        const defaultFilters = defaultsDeep( {}, DEFAULT_FILTERS );
        this.filtersMap.set( plotId, new BehaviorSubject( defaultFilters ) );
    }

    /** return the most recent value for filters */
    getFilters( plotId: string ) {
        return this.filtersMap.get( plotId ).getValue();
    }

    /** return the observable that updates whenever we update this plots filters */
    getFilters$( plotId: string ) {
        return this.filtersMap.get( plotId );
    }

    /** set the behaviour subjects value to our new filters value */
    setFilters( plotId: string, newFilters: IFilters ) {
        this.filtersMap.get( plotId ).next( newFilters );
    }
}
